import type { TokenDefinition, } from "@bracket/chainography";
import * as G from "@globals";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getBalance, } from "wagmi/actions";



/**
 * Gets the input balance for a given token
 * @param {Object} params - The parameters object
 * @param {TokenDefinition} params.token - The token to get the balance for
 * @returns {Promise<bigint>} The balance of the token
 * @throws {Error} If no wallet is connected or if the balance value is invalid
 */
export const getTokenBalance = async ({
	token,
}: {
	token: TokenDefinition;
}): Promise<bigint> => {
	const { address, } = G.wallet.getBracketWallet();
	if(!address)
		throw new Error("SwapStore::getInputBalance was invoked whilst a wallet was not set");
	const { value, } = await getBalance(config, {
		address,
		token: token.symbol === "ETH" ? undefined : token.address,
	});
	if(typeof value === "bigint") {
		return value;
	}
	throw new Error("SwapStore::getInputBalance failed to receive a valid value");
}
